import { createV2UsersMeOffHourSelector } from "./createV2UsersMeOffHourSelector";
import { RootState } from "../../../store";
export const duplicateMeOffHoursLoadingSelector = (
  state: RootState,
  id: string,
) => {
  return createV2UsersMeOffHourSelector(id)(state)?.isLoading;
};
